import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import I18n from 'common/i18n';
import { SIZES, VARIANTS } from 'common/components/Button';
import { ForgeButton, ForgeIcon } from '@tylertech/forge-react';
import { Hierarchy, HierarchyColumnConfig } from 'common/visualizations/vif';

import { newTableHierarchy } from 'common/authoring_workflow/actions';
import { getTableColumns, getTableHierarchies } from 'common/authoring_workflow/selectors/vifAuthoring';
import { MAX_HIERARCHIES } from 'common/authoring_workflow/constants';
import { AuthoringWorkflowState } from 'common/authoring_workflow/reducers/types';

const scope = 'shared.visualizations.panes.data';

const AddHierarchyLink = () => {
  const dispatch = useDispatch();
  const numberOfHierarchies: number = useSelector(
    (state: AuthoringWorkflowState) => getTableHierarchies(state.vifAuthoring).length
  );

  const disabled = useSelector((state: AuthoringWorkflowState) => {
    const tableColumns: HierarchyColumnConfig[] = getTableColumns(state.vifAuthoring);
    const tableColumnsDontExist = isEmpty(tableColumns);
    const tableHierarchies: Hierarchy[] = getTableHierarchies(state.vifAuthoring);
    return tableHierarchies.length >= MAX_HIERARCHIES || tableColumnsDontExist;
  });
  const buttonAttributes = {
    id: 'add-hierarchy-link',
    disabled: disabled,
    onClick: () => {
      dispatch(newTableHierarchy());
    },
    variant: VARIANTS.LINK,
    size: SIZES.SMALL
  };

  // It appears impossible to have 0 hierarchies, so I'm not sure when the second text would be used.
  const linkTitleTabs = numberOfHierarchies
    ? I18n.t('fields.table_hierarchies.flexible_add_another_value', { scope })
    : I18n.t('fields.table_hierarchies.flexible_add_value', { scope });

  const testid = numberOfHierarchies ? 'add-another-value' : 'add-value';

  return (
    <div className="add-link-container">
      <ForgeButton data-testid={testid} {...buttonAttributes}>
        <ForgeIcon name="add" slot="start" />
        {linkTitleTabs}
      </ForgeButton>
    </div>
  );
};

export default AddHierarchyLink;
